class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      const line = this.dataset.index;
      const variantId = this.dataset.variantId; // Assuming variant ID is set as a dataset attribute
      const name = document.activeElement.getAttribute('name');

      console.log("Remove Clicked");
      console.log(line);
      console.log(variantId);
      console.log(name);
      
      await cartItems.updateQuantity(line, 0, name, variantId);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    //OMAIR
    document.addEventListener('DOMContentLoaded', () => {
      console.log('DOM fully loaded and parsed');
      this.updateCartIconBubble();
      // Initialize listeners on load
      this.initAddToCartListeners();

      // Debounced listener for 'productRecommendationsLoaded' event
      const debouncedInitAddToCartListeners = debounce(() => {
        this.initAddToCartListeners(); // Reinitialize Add to Cart listeners
      }, 300); // Adjust the debounce time as needed

      // Listen for product recommendations to load and reinitialize listeners
      document.addEventListener('productRecommendationsLoaded', debouncedInitAddToCartListeners);
    });

    // Add the listener for the custom event 'productRecommendationsLoaded'
    document.addEventListener('productRecommendationsLoaded', () => {
      console.log('Caught productRecommendationsLoaded event in CartItems');
      this.initAddToCartListeners(); // Reinitialize the Add to Cart listeners
    });
  }

  // Function to initialize Add to Cart listeners
  async initAddToCartListeners() {
    const addToCartButtons = document.querySelectorAll('.product-form__submit, .quick-add__submit');

    addToCartButtons.forEach((button) => {
      // Find the nearest form element to this button
      const form = button.closest('form');

      // Remove any previous click event listener to avoid duplicates
      button.removeEventListener('click', this.handleAddToCartClick);

      // Add a new event listener
      button.addEventListener('click', this.handleAddToCartClick.bind(this, form));
    });
  }

  // Handle Add to Cart click
  async handleAddToCartClick(form, event) {
    // event.preventDefault();
    const button = event.target;

    // Check if the button is already processing a request
    if (button.getAttribute('data-loading') === 'true') {
      console.log('Button is already in loading state, skipping duplicate click.');
      return;
    }

    // Set loading state to prevent multiple requests
    button.setAttribute('data-loading', 'true');
    this.toggleCheckoutButton(false);

    const userProvince = localStorage.getItem('userProvince');
    if (!userProvince) {
      alert('Please select a province before adding to cart.');
      this.highlightProvinceSelection();
      button.setAttribute('data-loading', 'false');
      event.preventDefault();
      return;
    }

    // Proceed to add the product to the cart
    console.log('Add to Cart button clicked');
    const formData = new FormData(form);

    try {
      await this.addProductToCart(formData);
    } finally {
      // Reset the button's loading state after the request completes
      button.setAttribute('data-loading', 'false');
      this.toggleCheckoutButton(true);
      console.log("UPDATED")
    }
  }

  toggleCheckoutButton(isEnabled) {
  const checkoutButton = document.getElementById('CartDrawer-Checkout'); // Adjust selector as needed
  console.log("CHECKOUT BUTTON TOGGLED", checkoutButton);
  
  if (checkoutButton) {
    checkoutButton.disabled = !isEnabled;
    
    // Add or remove styles based on whether the button is enabled or disabled
    if (!isEnabled) {
      checkoutButton.style.backgroundColor = '#ccc !important'; // Set to gray or another "disabled" color
      checkoutButton.style.cursor = 'not-allowed !important';   // Change cursor to indicate disabled state
    } else {
      checkoutButton.style.backgroundColor = '#fff';  // Reset to default
      checkoutButton.style.cursor = 'pointer';           // Reset cursor to default
    }
  }
}

  // Highlight province selection if it isn't selected
  highlightProvinceSelection() {
    const provinceSelect = document.getElementById('newProvinceSelect');
    if (provinceSelect) {
      provinceSelect.style.border = '2px solid red';
      provinceSelect.style.boxShadow = '0 0 10px red';
      provinceSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        provinceSelect.style.border = '';
        provinceSelect.style.boxShadow = '';
      }, 3000);
    }
  }

  // Adding a product to the cart with the province check and excise tax logic
  async addProductToCart(formData) {
    this.toggleCheckoutButton(false);     //
    const userProvince = localStorage.getItem('userProvince');
    console.log("addProductToCart triggered");
    
    // Proceed to add the main product
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
    const productData = await response.json();
    console.log('Product added:', productData);
    
    // Add excise tax products linked to the main product
    await this.addExciseTaxToCart(productData.product_id, productData.product_type, productData.quantity, userProvince);
  }

  // Method to add or update excise tax products based on province and product type
  async addExciseTaxToCart(productId, productType, quantity, province) {
    this.toggleCheckoutButton(false);      //
    console.log("ProductId: ", productId);
    console.log("ProductType: ", productType);
    console.log("Quantity: ", quantity);
  
    // Get the excise tax products based on the product type and province
    const exciseTaxProducts = this.getExciseTaxProducts(province);
    console.log('Excise Tax Products:', exciseTaxProducts);
  
    // Fetch the current cart to check for existing excise tax line items
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    console.log("ADD: ", cartData);
    

    // Calculate the cumulative quantity of all products with the same product type
    let cumulativeQuantity = 0;
  
    cartData.items.forEach((item) => {
       if (item.title.toLowerCase() === "feed battery - black" || 
          item.title.toLowerCase() === "feed battery - navy blue" || 
          item.title.toLowerCase() === "feed battery - rose gold" ||
          item.product_type.toLowerCase() === "excise tax") {
            console.log("Skipping excise tax for product: ", item.title) 
            return; // Do not apply excise tax if it matches
        } else {
         cumulativeQuantity += item.quantity;
        }        
    });

    console.log(cumulativeQuantity);
  
    const exciseVariantIds = [
      exciseTaxProducts.federal.productId,
      exciseTaxProducts.provincial ? exciseTaxProducts.provincial.productId : null,
    ].filter(Boolean);
  
    const lineItemsToUpdate = cartData.items.filter((item) =>
      exciseVariantIds.includes(item.variant_id)
    );
    console.log(lineItemsToUpdate);

    
  
    // Update existing excise tax items if they are already in the cart
    for (const lineItem of lineItemsToUpdate) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: `${lineItem.id}`,
          quantity: cumulativeQuantity,
        }),
      });
    }
  
    // If excise tax items do not exist, add them to the cart
    const exciseItemsToAdd = [];
  
    if (!lineItemsToUpdate.some((item) => item.variant_id === exciseTaxProducts.federal.productId)) {
      exciseItemsToAdd.push({
        id: exciseTaxProducts.federal.productId,
        quantity: cumulativeQuantity,
      });
    }
  
    if (exciseTaxProducts.provincial && !lineItemsToUpdate.some((item) => item.variant_id === exciseTaxProducts.provincial.productId)) {
      exciseItemsToAdd.push({
        id: exciseTaxProducts.provincial.productId,
        quantity: cumulativeQuantity,
      });
    }
  
    if (exciseItemsToAdd.length > 0) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: exciseItemsToAdd }),
      });
  
      const exciseResponse = await response.json();
      console.log('Excise items added:', exciseResponse);
    }
  
  // Update cart drawer UI after adding or updating excise tax items
    await this.updateCartDrawerUI();
    await this.updateCartIconBubble();
  }

  getExciseTaxProducts(province) {
    // Define mappings for excise tax products based on province and collection
    const exciseTaxProducts = {
      Federal: {
        'Federal': { productId: 44494271774820 }, 
      },
      Provincial: {
        'ON': { productId: 44494273609828 },
        'QC': { productId: 44494275969124 },
        'NU': { productId: 44494277279844 },
        'NT': { productId: 44494276067428 },
        'AB': { productId: 45594648182884 },
        'MB': { productId: 45594667122788 },
        'NB': { productId: 45594672431204 },
        'YT': { productId: 45594697302116 },
        'PE': { productId: 45594721648740 },
        // 'AB','MB','NB','YT','NB'
      },
    };

     if (!exciseTaxProducts.Provincial[province]) {
    console.log("Provincial tax not found for ", province);
} else {
    console.log("Provincial tax found:", exciseTaxProducts.Provincial[province]);
}
    // Return federal and provincial product IDs for the collection
    return {
     
      federal: exciseTaxProducts['Federal']['Federal'],
      provincial: exciseTaxProducts['Provincial'][province],
    };
  }


  // Update excise tax quantity cumulatively for all products of the same type
  async updateExciseTax(variantId, quantityChange, province) {
    console.log("QC: ", quantityChange);
    const exciseTaxProducts = this.getExciseTaxProducts(province);
    
    if (!exciseTaxProducts) return;
    console.log(exciseTaxProducts);
    // Fetch the current cart to get all line items
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    console.log(cartData);
  
    // Calculate the cumulative quantity of all products with the same product type
    let cumulativeQuantity = 0;
  
    cartData.items.forEach((item) => {
       if (item.title.toLowerCase() === "feed battery - black" || 
          item.title.toLowerCase() === "feed battery - navy blue" || 
          item.title.toLowerCase() === "feed battery - rose gold" ||
          item.product_type.toLowerCase() === "excise tax") {
            console.log("Skipping excise tax for product: ", item.title) 
            return; // Do not apply excise tax if it matches
        } else {
         cumulativeQuantity += item.quantity;
        }        
    });

    console.log(cumulativeQuantity);
  
    // Find the excise tax line items in the cart
    const exciseVariantIds = [
      parseInt(exciseTaxProducts.federal.productId, 10),
      exciseTaxProducts.provincial ? parseInt(exciseTaxProducts.provincial.productId, 10) : null,
    ].filter(Boolean);

    console.log(exciseVariantIds);
  
    const lineItemsToUpdate = cartData.items.filter((item) =>
      exciseVariantIds.includes(item.variant_id)
    );

    console.log(lineItemsToUpdate);
  
    // Update the quantity of the excise items in the cart based on the cumulative quantity
    for (const lineItem of lineItemsToUpdate) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: `${lineItem.id}`,
          quantity: cumulativeQuantity,
        }),
      });
    }
  }




///////////////////////////////////////////
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  // onChange(event) {
  //   this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  // }
  /////////////
  async onChange(event) {  
    const line = event.target.dataset.index;
    const quantity = event.target.value;
    const name = document.activeElement.getAttribute('name');
    const variantId = event.target.dataset.quantityVariantId;
    const inputElement = event.target.closest('input[name="quantity"]');
    const productType = event.target.dataset.productType;

    console.log(event.target.dataset);
    console.log(line);
    console.log(quantity);
    console.log(name);
    console.log(variantId);
    console.log(productType);

    // Log product type for debugging
    console.log("Product Type: ", productType);
    // this.toggleCheckoutButton(false)
    // Update quantity of main product
    await this.updateQuantity(line, quantity, name, variantId, productType);
     // this.toggleCheckoutButton(false)

    // Handle excise tax update based on the product and quantity
    const userProvince = localStorage.getItem('userProvince');
    if (userProvince) {
      await this.updateExciseTax(variantId, quantity, userProvince);  // Pass productType to the excise tax updater
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          // location.reload();  //OMAIR
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          // location.reload();  //OMAIR
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const checkoutButton = document.getElementById('CartDrawer-Checkout');
    this.toggleCheckoutButton(false);

    try {
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      const state = await response.text();  
      const parsedState = JSON.parse(state);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
      this.toggleCheckoutButton(false);
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
      }

      // Update excise tax items quantity based on cumulative changes
      const userProvince = localStorage.getItem('userProvince');
      // if (item.title.toLowerCase() === "feed battery - black" || 
      //   item.title.toLowerCase() === "feed battery - navy blue" || 
      //   item.title.toLowerCase() === "feed battery - rose gold") {
      //     console.log("Skipping excise tax for product: ", item.title)
      // } else{
        if (userProvince) {
          console.log("A")
          await this.updateExciseTax(variantId, quantity, userProvince);
          console.log("B")
        }
      // }  
      console.log("C")
      await this.updateCartDrawerUI();
      await this.updateCartIconBubble();
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      // location.reload();  //OMAIR
    } catch(error) {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        console.error("Error updating quantity: ", error);
    } finally {
        this.disableLoading(line);
        console.log('E')
        console.log(checkoutButton);
        this.toggleCheckoutButton(true);
      }
  }


  async updateCartDrawerUI() {
    try {
      // Fetch the latest cart sections
      const response = await fetch(`${routes.cart_url}?section_ids=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer`);
      const htmlText = await response.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(htmlText, 'text/html');
  
      // Update the cart drawer
      const newCartDrawer = html.querySelector('#CartDrawer');
      const currentCartDrawer = document.querySelector('#CartDrawer');
      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
      }
  
      // Update the main cart items
      const newCartItems = html.querySelector('#main-cart-items');
      const currentCartItems = document.querySelector('#main-cart-items');
      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }
  
      // Update the footer if it exists
      const newFooter = html.querySelector('#main-cart-footer');
      const currentFooter = document.querySelector('#main-cart-footer');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }
  
      // Update cart icon bubble (for the cart count, etc.)
      const newCartBubble = html.querySelector('#cart-icon-bubble');
      const currentCartBubble = document.querySelector('#cart-icon-bubble');
      if (newCartBubble && currentCartBubble) {
        currentCartBubble.innerHTML = newCartBubble.innerHTML;
      }
  
      // Check if the cart is empty by looking for 'cart__contents' or item count
      const cartContents = html.querySelector('.cart__contents');
      const isCartEmpty = cartContents && cartContents.querySelectorAll('.cart-item').length === 0;
  
      // Toggle 'is-empty' class on cart drawer if the cart is empty
      const cartDrawer = document.querySelector('cart-drawer');
      if (isCartEmpty) {
        cartDrawer.classList.add('is-empty');
      } else {
        cartDrawer.classList.remove('is-empty');
      }
  
      // Disable the checkout button if the cart is empty
      // const checkoutButton = document.getElementById('CartDrawer-Checkout');
      // if (checkoutButton) {
      //   checkoutButton.disabled = isCartEmpty;
      // }
  
    } catch (error) {
      console.error('Error updating cart drawer UI:', error);
    }
  }

  async updateCartIconBubble() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
  
      // Calculate the item count, excluding excise tax items
      let itemCount = 0;
      console.log("CART: ", cart);
      cart.items.forEach(item => {
        console.log("HHHH: ", item);
        console.log(item.product_type !== 'excise tax');
        console.log(item.product_type);
        
        // Check if item.product exists and has tags before accessing them
        if (item && item.product_type !== 'excise tax') {
          itemCount += item.quantity;
          console.log("ITEM ADDED TO ITEM COUNT");
        }
      });
  
      // Update the cart icon bubble
      const cartIconBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span');
      console.log(cartIconBubble);
      if (itemCount > 0) {
        console.log("ITEMCOUNT: ",itemCount);
        cartIconBubble.innerText = itemCount;
        console.log("InnerText: ",cartIconBubble.innerText);
        cartIconBubble.parentElement.style.display = 'block';  // Ensure the bubble is shown
      } else {
        cartIconBubble.parentElement.style.display = 'none';   // Hide bubble when count is 0
      }
  
    } catch (error) {
      console.error('Error updating cart icon bubble:', error);
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
